import React from "react";

import type { TextFieldProps as UITextFieldProps } from "../../UI/TextField";
import { TextField as UITextField } from "../../UI/TextField";
import { InputLabel } from "../../UI/InputLabel";

export interface TextFieldProps extends UITextFieldProps {
  errors?: Record<string, any>;
}

export const TextField: React.FC<TextFieldProps & any> = React.forwardRef((props, ref) => (
  <>
    {props.label && <InputLabel htmlFor={props.id}>{props.label}</InputLabel>}
    <UITextField {...(props as any)} ref={ref} />
  </>
));
